import { graphql } from "@opensea/graphql"

export const useSwapGasCheckFragment = graphql(`
  fragment useSwapGasCheckFragment on SwapQuote {
    swapRoutes {
      ... on SwapRoute {
        costs {
          costType
          cost {
            token {
              unit
              symbol
              address
              chain {
                identifier
              }
            }
          }
        }
        fromAsset {
          ... on Currency {
            symbol
            chainIdentifier
          }
        }
        pricePerFromAsset {
          token {
            unit
          }
        }
      }
    }
  }
`)
